import React from 'react';
import PropTypes from 'prop-types';
// import { useRouter } from 'next/router';
// import { useNavigate } from 'react-router-dom';

function PageHeader({
  pageHeading, pageType, breadCrumb, marginClass, showHeading = true,
}) {
  // const backPage = useRouter();

  return (
    <header className={`${marginClass || 'lg:mb-3'} my-4 lg:my-0 lg:pt-4`}>
      <div className="container mx-auto">
        <small className={`${pageType === 'bookmark' ? '!hidden' : ''} text-blue-800 block font-normal text-xs lg:line-clamp-none !line-clamp-1`}>{breadCrumb}</small>
        <div className="flex items-center lg:justify-start justify-between">
          <div className="flex">
            {/* <span className="lg:hidden block pe-2 cursor-pointer" onClick={() => backPage.back()}>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.46875 11.7188H21.0938C21.301 11.7188 21.4997 11.8011 21.6462 11.9476C21.7927 12.0941 21.875 12.2928 21.875 12.5C21.875 12.7072 21.7927 12.9059 21.6462 13.0524C21.4997 13.1989 21.301 13.2812 21.0938 13.2812H5.46875C5.26155 13.2812 5.06284 13.1989 4.91632 13.0524C4.76981 12.9059 4.6875 12.7072 4.6875 12.5C4.6875 12.2928 4.76981 12.0941 4.91632 11.9476C5.06284 11.8011 5.26155 11.7188 5.46875 11.7188Z" fill="black" />
                <path d="M5.79212 12.5L12.2718 18.9781C12.4185 19.1248 12.5009 19.3238 12.5009 19.5313C12.5009 19.7387 12.4185 19.9377 12.2718 20.0844C12.1251 20.2311 11.9261 20.3135 11.7187 20.3135C11.5112 20.3135 11.3123 20.2311 11.1656 20.0844L4.13431 13.0531C4.06155 12.9806 4.00383 12.8944 3.96444 12.7994C3.92506 12.7045 3.90479 12.6028 3.90479 12.5C3.90479 12.3972 3.92506 12.2955 3.96444 12.2006C4.00383 12.1057 4.06155 12.0195 4.13431 11.9469L11.1656 4.91564C11.3123 4.76894 11.5112 4.68652 11.7187 4.68652C11.9261 4.68652 12.1251 4.76894 12.2718 4.91564C12.4185 5.06233 12.5009 5.2613 12.5009 5.46876C12.5009 5.67622 12.4185 5.87519 12.2718 6.02189L5.79212 12.5Z" fill="black" />
              </svg>
            </span> */}
            {/* <h1 className="lg:text-[22px] font-semibold text-base pe-4">{pageHeading}</h1> */}
            <span
              className={`${
                showHeading
                  ? 'lg:text-lg text-base font-semibold pe-4'
                  : 'hidden'
              }`}
            >
              {pageHeading}
            </span>
          </div>
          {/* <span className="cursor-pointer" onClick={() => openModal('InfoMessage')}>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" stroke="#0F172A" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11 9.38867V16.7571" stroke="#0F172A" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.3025 6.2206C11.3025 6.38775 11.167 6.52323 10.9999 6.52323C10.8327 6.52323 10.6973 6.38775 10.6973 6.2206C10.6973 6.05346 10.8328 5.91797 10.9999 5.91797C11.167 5.91797 11.3025 6.05346 11.3025 6.2206Z" fill="black" stroke="#0F172A" strokeWidth="1.5" />
              </svg>
            </span> */}
        </div>
      </div>
    </header>
  );
}
PageHeader.propTypes = {
  pageHeading: PropTypes.any,
  pageType: PropTypes.string,
  breadCrumb: PropTypes.any,
  marginClass: PropTypes.any,
  showHeading: PropTypes.bool,
};

export default PageHeader;
